<template>
  <div>
    <el-dialog
      :title="$t('lang.onAndOf.OnlineAndOfflineRecords')"
      :visible.sync="show"
      width="800px"
      @close="closeDialog"
    >
      <div class="header">
        <el-date-picker
          v-model="time"
          type="datetimerange"
          :range-separator="$t('lang.Monitor.to')"
          :start-placeholder="$t('lang.switchCrad.startDate')"
          :end-placeholder="$t('lang.switchCrad.endDate')"
          size="mini"
          @change="timeChanger"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
        <el-button type="primary" size="mini" @click="refresh">{{
          $t("lang.switchCrad.Inquire")
        }}</el-button>
      </div>
      <el-table :data="dataList" border style="width: 100%;margin-top:10px;">
        <el-table-column
          type="index"
          :label="$t('lang.switchCrad.serialNumber')"
          width="80px"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="attackTime"
          :label="$t('lang.onAndOf.time')"
          align="center"
        ></el-table-column>
        <el-table-column :label="$t('lang.onAndOf.type')" align="center">
          <template slot="header" slot-scope="scope">
            <el-select v-model="type" size="mini">
              <el-option
                :label="$t('lang.onAndOf.offline')"
                :value="0"
              ></el-option>
              <el-option
                :label="$t('lang.onAndOf.online')"
                :value="1"
              ></el-option>
              <el-option :label="$t('lang.onAndOf.all')" :value="2"></el-option>
            </el-select>
          </template>
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.type == 1">{{
              $t("lang.onAndOf.online")
            }}</el-tag>
            <el-tag type="danger" v-if="scope.row.type == 0">{{
              $t("lang.onAndOf.offline")
            }}</el-tag>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :total="total"
        :offset="offset"
        :limit="limit"
        @SizeChanges="SizeChanges"
        @CurrentChanges="CurrentChanges"
      ></pagination>
      <div slot="footer" class="footer">
        <el-button @click="show = false">{{
          $t("lang.switchCrad.Cancel")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import http from "@/axios/http.js";
import pagination from "@/components/pagination";
export default {
  name: "onAndOf",
  data() {
    return {
      show: false,
      time: [
        new Date(Date.now() - 1000 * 60 * 60 * 12)
          .toLocaleString("zh")
          .replace(/[\/]/g, "-"),
        new Date().toLocaleString("zh").replace(/[\/]/g, "-"),
      ],
      type: 0,
      total: 0,
      offset: 1,
      limit: 10,
      did: "",
      dataList: [],
    };
  },
  components: {
    pagination,
  },
  methods: {
    refresh(v) {
      if (v && v.deviceDid) this.did = v.deviceDid;
      http({
        url: "/api/device/upDownRecordList",
        method: "post",
        data: {
          did: this.did,
          type: this.type == 2 ? undefined : this.type,
          sts: this.time[0],
          ets: this.time[1],
          offset: this.offset,
          limit: this.limit,
        },
      }).then((res) => {
        if (res.data.code == 0) {
          this.total = res.data.data.total;
          this.dataList = res.data.data.list;
        } else {
          this.$message({
            type: "error",
            message: this.$t("lang.onAndOf.GetFailed"),
          });
        }
      });
    },
    timeChanger() {
      this.refresh();
    },
    SizeChanges(v) {
      this.limit = v;
      this.refresh();
    },
    CurrentChanges(v) {
      this.offset = v;
      this.refresh();
    },
    closeDialog() {
      this.time = [
        new Date(Date.now() - 1000 * 60 * 60 * 12)
          .toLocaleString("zh")
          .replace(/[\/]/g, "-"),
        new Date().toLocaleString("zh").replace(/[\/]/g, "-"),
      ]
    },
  },
};
</script>
<style scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.footer {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
</style>
